import type { DesignChangeReviewStatus, DRBFMWorkflowResponse } from '../../../types/drbfm';
import type { WorkflowStartValue } from './DRBFMWorkflowStartStep';

export const initialStartValue: WorkflowStartValue = {
  workflowPhase: 'concept_estimate',
  inputPattern: 'old_new_documents',
  changeGranularity: 'coarse',
};

// The derived title appends a locale suffix to itemName, so a legal 500-code-point item
// name overflows title's own column: 017_drbfm_tables.sql:17 title VARCHAR(500).
export const clampSessionTitle = (title: string) => Array.from(title).slice(0, 500).join('');

export const countReviewedDesignChanges = (workflow: DRBFMWorkflowResponse | null) =>
  (workflow?.designChanges || []).filter((change) => (
    ['accepted', 'modified'].includes((change.reviewStatus || '') as DesignChangeReviewStatus)
  )).length;

export const countReviewedFailureModes = (workflow: DRBFMWorkflowResponse | null) =>
  (workflow?.failureModes || []).filter((mode) => (
    ['accepted', 'modified'].includes(mode.reviewStatus)
    && mode.countermeasureRequirement === 'required'
  )).length;
